module.exports = __webpack_public_path__ + "static/media/espumaNylon.359bf18e.png";